import {
  Component,
  Input,
  OnInit,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { unitType } from "../../../shared/unit-type/unit-type.const";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-unit-type-select",
  templateUrl: "./unit-type-select.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, FormsModule],
})
export class UnitTypeSelectComponent implements OnInit {
  public readonly unitTypeChange = output();
  @Input() public unitType = "Select unit type";
  public readonly disabled = input(false);

  public subscription = new Subscription();
  public unitTypeList: SelectItem[] = [];

  constructor() {}

  ngOnInit() {
    this.buildUnitTypeList();
  }

  public onUnitTypeChange(event) {
    this.unitTypeChange.emit(event.value);
  }

  private buildUnitTypeList() {
    Object.keys(unitType).map((key) => {
      this.unitTypeList.push({
        label: unitType[key],
        value: key,
      });
    });
  }
}
